import { useLoading } from 'shared/hooks'
import { useFollowZoneMutation } from '../graphql/mutation/followLabel.types'
import { useUnfollowZoneMutation } from '../graphql/mutation/unfollowLabel.types'
import { useUserZoneFollows } from './useUserZoneFollows'
import { GetUserZoneFollowsDocument } from '../graphql/queries/getUserZoneFollows.types'

import { LabelFollow } from 'shared/__gql-types'

export const useToggleFollowZone = () => {
  const { getZoneFollowed } = useUserZoneFollows()

  const [followZoneRequest, { loading: followLoading }] = useFollowZoneMutation({
    update(cache, { data }) {
      if (typeof data?.followLabel !== 'undefined') {
        const res = cache.readQuery<{ getUserLabelFollows: LabelFollow[] }>({
          query: GetUserZoneFollowsDocument
        })

        cache.writeQuery({
          query: GetUserZoneFollowsDocument,
          data: {
            getUserLabelFollows: [...res?.getUserLabelFollows ?? [], data.followLabel],
          }
        })
      }
    }
  })

  const [unfollowZoneRequest, { loading: unfollowLoading }] = useUnfollowZoneMutation({
    update(cache, { data }, { variables }) {
      if (typeof data?.unfollowLabel !== 'undefined') {
        const res = cache.readQuery<{ getUserLabelFollows: LabelFollow[] }>({
          query: GetUserZoneFollowsDocument
        })

        cache.writeQuery({
          query: GetUserZoneFollowsDocument,
          data: {
            getUserLabelFollows: res?.getUserLabelFollows?.filter((follows) => follows.label_id !== variables?.label_id)
          }
        })
      }
    }
  })

  const followZone = (zoneId: string) => followZoneRequest({ variables: { label_id: zoneId } })
  const unfollowZone = (zoneId: string) => unfollowZoneRequest({ variables: { label_id: zoneId } })
  const onToggleZone = (zoneId: string) => getZoneFollowed(zoneId) ? unfollowZone(zoneId) : followZone(zoneId)

  useLoading({ isLoading: followLoading || unfollowLoading })

  return {
    onToggleZone,
    getZoneFollowed,
    followZone,
    unfollowZone
  }
}